module.exports = __webpack_public_path__ + "static/media/27.af5f9b78.wav";